import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetPairsFrameLensByOrderInput } from './GetPairsFrameLensByOrderInput';
import { GetPairsFrameLensByOrderOutput } from './GetPairsFrameLensByOrderOutput';

export class GetPairsFrameLensByOrderService extends HttpServiceBase {

  handle = (input?: GetPairsFrameLensByOrderInput): Promise<Result<GetPairsFrameLensByOrderOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetPairsFrameLensByOrderOutput>>(`${this.baseUrlSislogApi}/v2/recipe-by-product/pairs-frame-lens${parameters}`);
    return promise;
  }
}